import { ContractState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
    adminContracts: (cstate: ContractState) => cstate.contracts,
    adminOneContract: (cstate: ContractState) => (key1: string) => {
        const filteredContracts = cstate.contracts.filter((contract) => contract.key1 === key1);
        if (filteredContracts.length > 0) {
            return { ...filteredContracts[0] };
        }
    },
};

const { read } = getStoreAccessors<ContractState, State>('');

export const readAdminOneContract = read(getters.adminOneContract);
export const readAdminContracts = read(getters.adminContracts);
